<template>
    <v-dialog :value="showDialog" max-width="320" @input="$emit('close')">
        <v-card>
            <v-card-title class="headline pr-3">
                <span>{{ $t("Members list") }}</span>
                <v-spacer></v-spacer>
                <icon-button
                    icon="X"
                    @click="$emit('close')"
                />
            </v-card-title>
            <v-card-text class="body-1">
                <v-row v-for="person in groupMembers" :key="person.id">
                    <v-col class="col-12 pb-2 pt-1">
                        <v-avatar :color="person.avatar ? 'white' : 'grey lighten-2'" size="24" class="mr-3">
                            <img v-if="person.avatar" :alt="person.initials" :src="baseUrl + person.avatar" />
                            <span v-else class="caption blue-grey--text text--darken-1">
                                {{ person.initials }}
                            </span>
                        </v-avatar>
                        {{ person.name }}
                    </v-col>
                </v-row>
            </v-card-text>
        </v-card>
    </v-dialog>
</template>

<script>
import { computed } from "@vue/composition-api";
import {useMemberStore} from "../store/modules/member";

export default {
    name: "AccountGroupMembersDialog",
    components: {},
    props: {
        baseUrl: {
            type: String,
            required: true
        },
        groupId: {
            type: Number,
            required: true
        },
        showDialog: {
            type: Boolean,
            required: true
        }
    },
    setup(props) {
        const memberStore = useMemberStore()

        const groupMembers = computed(() => {
            return memberStore.getGroupMembers(props.groupId)
        })

        return {
            groupMembers
        };
    }
};
</script>
